import * as React from 'react';
import gql from 'graphql-tag';
import {
  CoreShopSettingsVatIds,
  core_apimessages_TaxIdentification as TaxIdentification,
} from '../schemas/rql';
import { ChildProps, graphql } from 'react-apollo';
import { I18N as Translate } from '@reverbdotcom/commons/dist/components/translate';
import FormGroup from '@reverbdotcom/commons/dist/components/form_group';
import { ISelectOption } from '@reverbdotcom/commons/dist/components/form_group_with_select';

export interface ExternalProps {
  countryOptions: ISelectOption[];
}

type Props = ChildProps<ExternalProps, CoreShopSettingsVatIds.Query>;

export function ShopSettingsVatIds({ data, countryOptions }: Props) {
  if (data?.loading) {
    return null;
  }

  return (
    <ul className="actionable-rows mb-1">
      {
        data.me.shop.taxIdentifications.map(taxIdentification => (
          <ShopSettingsVatId
            taxIdentification={taxIdentification}
            countryOptions={countryOptions}
            key={taxIdentification.id}
          />
        ))
      }
    </ul>
  );
}

interface VatIdProps {
  taxIdentification: TaxIdentification;
  countryOptions: ISelectOption[];
}

export function ShopSettingsVatId(props: VatIdProps) {
  const { taxIdentification, countryOptions } = props;
  const { countryCode, taxId, status } = taxIdentification;

  const countryName = countryOptions.find(country => country.value === countryCode).text;
  const statusKey = status.toLocaleLowerCase();

  return (
    <li
      className="actionable-row"
      key={taxId}
      id={taxId}
    >
      <div className="actionable-row__content">
        <div className="g-container">
          <div className="g-col-4 g-col-mobile-12">
            <FormGroup
              label="VAT Identification Number">
              <code>
                {taxId}
              </code>
            </FormGroup>
          </div>
          <div className="g-col-4 g-col-mobile-12 mobile-mt-2">
            <FormGroup label="Country">
              {countryName}
            </FormGroup>
          </div>
          <div className="g-col-4 g-col-mobile-12 mobile-mt-2">
            <FormGroup label="Status">
              <Translate text={`discovery.shopSettings.vat.statuses.${statusKey}`} />
            </FormGroup>
          </div>
        </div>
      </div>
      <ul className="actionable-row__actions">
        <button
          className="button-as-link icon-l-pencil"
          type="button"
        >
          <Translate text="discovery.shopSettings.vat.edit" />
        </button>
      </ul>
    </li>
  );
}

const VAT_ID_QUERY = gql`
  query Core_ShopSettings_VatIds {
    me {
      uuid
      shop {
        _id
        taxIdentifications {
          id
          taxId
          taxType
          status
          countryCode
        }
      }
    }
  }
`;

const withQuery = graphql<ExternalProps, CoreShopSettingsVatIds.Query>(VAT_ID_QUERY);

export default withQuery(ShopSettingsVatIds);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shop_settings_vat_ids.tsx